import React from 'react';
import './Skeleton.css';

/**
 * SkeletonCell Component
 * 
 * Atomic component - renders a single placeholder cell
 * Responsibility: Display one animated grey box
 * Reusable: Can be used in any table, card, or list
 * 
 * Principles:
 * - Single Responsibility: Only renders one skeleton box
 * - Composition: Building block for larger components
 * - DRY: Reusable everywhere
 */
export default function SkeletonCell({ 
  width = '100%', 
  height = '16px',
  style = {} 
}) {
  return (
    <div 
      className="skeleton-box" 
      style={{ 
        width, 
        height,
        maxWidth: width, // Prevent overflow
        ...style 
      }}
      aria-hidden="true" // Accessibility: hide from screen readers
      role="presentation"
    />
  );
}
